import { useIntl } from "react-intl";
import IEmailMergeVar from "../../../../models/IEmailMergeVar";

type Props = {
    mergeVars: IEmailMergeVar[];
    scope: "order" | "account";
    onInsert: (mergeVar: string) => void;
    disabled?: boolean;
    className?: string;
};

/** A select that inserts a `%VAR%` placeholder wherever the caller decides. */
const MergeVarPicker = (props: Props) => {
    const intl = useIntl();
    const vars = props.mergeVars.filter((v) => v.group === "general" || v.group === props.scope);

    return (
        <select
            className={`form-select form-select-sm ${props.className || ""}`}
            value={""}
            disabled={props.disabled}
            aria-label={intl.formatMessage({ id: "insert_variable" })}
            data-testid={"merge-var-picker"}
            onChange={(e) => {
                if (e.target.value) {
                    props.onInsert(e.target.value);
                }
            }}>
            <option value={""}>{intl.formatMessage({ id: "insert_variable" })}</option>
            {vars.map((v) => (
                <option key={v.var} value={v.var} title={intl.formatMessage({ id: v.descriptionKey, defaultMessage: v.description })}>
                    {v.var} — {intl.formatMessage({ id: v.descriptionKey, defaultMessage: v.description })}
                </option>
            ))}
        </select>
    );
};

export default MergeVarPicker;
